<template>
    <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
            <p class="modal-card-title">
                <b-icon icon="paperclip" class="m-2"></b-icon>
                Fichiers joints
            </p>
        </header>
        <section class="modal-card-body">

            <b-field class="paperclip is-primary"
                     v-if="fileList.length < 6 && docadd">
                <b-upload v-model="files"
                          multiple
                          drag-drop
                          expanded
                          >
                    <div class="content has-text-centered">
                        <p class="up-margin">
                            <b-icon
                                    icon="upload"
                                    size="is-small">
                            </b-icon>
                            Téléverser vos fichiers à attacher ici. <br> Max 5 Mo.
                        </p>
                    </div>
                </b-upload>
            </b-field>
            <div class="tags">
                            <span v-for="(file, index) in files"
                                  :key="index"
                                  class="tag is-primary">
                                {{file.name}}
                                <button class="delete is-small"
                                        type="button"
                                        @click="deleteFile(index)">
                                </button>
                            </span>
            </div>

            <b-button
                    icon-left="upload"
                    type="is-success"
                    v-if="files.length"
                    @click.prevent="uploadFiles()">
                Téléverser les fichiers
            </b-button>

            <b-table
                    :data="fileList">

                <b-table-column field="name" label="Nom" v-slot="props">
                    {{ props.row.file }}
                </b-table-column>

                <b-table-column field="ct" label="Type" v-slot="props">
                    {{ props.row.details.content_type }}
                </b-table-column>

                <b-table-column field="get" label="Voir" v-slot="props">
                    <b-button
                            type="is-success"
                            icon-right="download"
                            size="is-small"
                            @click.prevent="getAttachment(props.row.file, props.row.docid)">
                    </b-button>
                </b-table-column>

                <b-table-column
                    v-if="docadd"
                    field="del"
                    label="Supprimer"
                    v-slot="props">
                    <b-button
                            type="is-danger"
                            icon-right="trash"
                            size="is-small"
                            @click.prevent="deleteAttachments(props.row.file, props.row.docid)">
                    </b-button>
                </b-table-column>

            </b-table>

        </section>
        <footer class="modal-card-foot">
            <button class="button" type="button is-primary" @click="backToList($parent)">
                Fermer
            </button>
        </footer>
    </div>
</template>

<script>
    export default {
        name: "Attachments",
        props: {
            docid: {
                type: String,
                required: true
            },
            docadd: {
              type: Boolean,
              required: true
            }
        },
        mounted() {
            this.getAttach(this.docid)
        },
        methods: {
            backToList(p){
                // Todo
                p.close()
                this.$router.push('/liste').catch(() => {})
            },
            checkFiles() {
                // console.log('check fiules')
                if (this.files.length + this.fileList.length > 5) {
                    this.$buefy.snackbar.open(
                        {
                            message: `Maximum 5 documents`,
                            type: 'is-danger',
                            position: 'is-bottom-left'
                        });
                    return false;
                } else {
                    let totalSize = 0;
                    this.files.forEach(f => {
                        totalSize += f.size / 1024 / 1024
                    });
                    if (totalSize > 10) {
                        this.$buefy.snackbar.open(
                            {
                                message: `Somme des documents trop importante. Maximum 10Mo`,
                                type: 'is-danger',
                                position: 'is-bottom-left'
                            });
                        return false
                    } else {
                        return true
                    }
                }
            },
            uploadFiles() {
                // Create a form data to send files to backend
                if (!this.checkFiles()) {
                    return null;
                }
                let formData = new FormData();
                formData.append('id', this.docid);
                if (this.files.length > 1) {
                    this.files.forEach(f => {
                        formData.append("attachments", f);
                    })
                } else if (this.files.length === 1) {
                    this.files.forEach(f => {
                        formData.append("attachment", f);
                    })
                }
                // Loading start here
                const loadingComponent = this.$buefy.loading.open({
                    container: null
                })
                this.$axios.post('addAttachments', formData, {})
                    .then(() => {
                        // if success
                        this.getAttach(this.docid)
                        this.files = []
                        // Resolve loading
                        loadingComponent.close()
                    })
                    .catch(function (error) {
                        //handle error
                        console.log(error);
                    });


            },
            deleteFile(index) {
                this.files.splice(index, 1)
            },
            getAttach(i) {
                this.$axios.get(`doc?id=${i}`)
                    .then((response) => {
                        this.fileList = [];
                        if (response.data.doc._attachments !== undefined) {
                            Object.entries(response.data.doc._attachments).forEach(f => {
                                let o = {}
                                o.docid = i
                                o.file = f[0]
                                o.details = f[1]
                                this.fileList.push(o)
                            });
                        }
                    })
            },
            getAttachment(file, docid) {
                this.$axios({
                    url: `getAttachment?attachment=${file}&docid=${docid}`,
                    method: 'GET',
                    responseType: 'blob'
                })
                    .then(function (response) {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', file); //or any other extension
                        document.body.appendChild(link);
                        link.click();
                    }.bind(this))
                    .catch(error => console.log(error));
            },
            deleteAttachments(file, docid) {
                this.$axios.get(`deleteAttachment?attachment=${file}&docid=${docid}`)
                    .then(() => {
                        this.getAttach(this.docid)
                    })
                    .catch(error => console.log(error));
            }
        },
        data() {
            return {
                fileList: [],
                files: []
            }
        },
    }
</script>

<style scoped>

</style>
